module.exports = __webpack_public_path__ + "img/tpay-orange.6d7b6f3d.png";